import attributes from './attributes'
import basic from './basic'
import common from './common'
import options from './options'
import preview from './preview'
import addons from './addons'
import projects from './projects'
import navigation from './navigation'
import template from './template'

export default {
  addons,
  attributes,
  basic,
  common,
  options,
  preview,
  projects,
  navigation,
  template
}
